(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8368,3096],{

/***/ 45923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconPaginationLeft = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 6,
  height: 10,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M5 9 1 5l4-4",
  stroke: "currentcolor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconPaginationLeft);

/***/ }),

/***/ 55610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconPaginationRight = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 6,
  height: 10,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "m1 9 4-4-4-4",
  stroke: "currentcolor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconPaginationRight);

/***/ }),

/***/ 98544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ addClass; }
});

;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

/***/ }),

/***/ 74277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ removeClass; }
/* harmony export */ });
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

/***/ }),

/***/ 93096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;


/***/ }),

/***/ 97901:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories",
      function () {
        return __webpack_require__(46125);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ elements_SlickSlider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/slider.js
var slider = __webpack_require__(5798);
// EXTERNAL MODULE: ./components/elements/SlickSlider/styles.module.scss
var styles_module = __webpack_require__(41227);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-review-prev.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconReviewPrev = props => /*#__PURE__*/react.createElement("svg", _extends({
  viewBox: "0 0 24 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M1 9h21.84M10.167 17 1 9l9.167-8",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ var icon_review_prev = (SvgIconReviewPrev);
;// CONCATENATED MODULE: ./public/icons/icon-review-next.svg
var icon_review_next_path;

function icon_review_next_extends() { icon_review_next_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_review_next_extends.apply(this, arguments); }



const SvgIconReviewNext = props => /*#__PURE__*/react.createElement("svg", icon_review_next_extends({
  viewBox: "0 0 24 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_review_next_path || (icon_review_next_path = /*#__PURE__*/react.createElement("path", {
  d: "M23 9H1.16M13.833 17 23 9l-9.167-8",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ var icon_review_next = (SvgIconReviewNext);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(79697);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./providers/modalProvider.js
var modalProvider = __webpack_require__(51472);
;// CONCATENATED MODULE: ./components/elements/SlickSlider/index.js

















var SlickSlider = function(_param) {
    var _pagination = _param.pagination, pagination = _pagination === void 0 ? false : _pagination, _arrows = _param.arrows, arrows = _arrows === void 0 ? true : _arrows, className = _param.className, slidesToShow = _param.slidesToShow, children = _param.children, nextArrow = _param.nextArrow, prevArrow = _param.prevArrow, _synced = _param.synced, synced = _synced === void 0 ? false : _synced, videos = _param.videos, cloudflare = _param.cloudflare, _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, props = (0,_object_without_properties/* default */.Z)(_param, [
        "pagination",
        "arrows",
        "className",
        "slidesToShow",
        "children",
        "nextArrow",
        "prevArrow",
        "synced",
        "videos",
        "cloudflare",
        "variant"
    ]);
    var ref = (0,ResponsiveContext/* useResponsive */.F)(), isLargeDesktop = ref.isLargeDesktop, isSmallMobile = ref.isSmallMobile;
    var CloudflareVideo = dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 9562).then(__webpack_require__.bind(__webpack_require__, 69562));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(69562)
                ];
            }
        }
    });
    var ref1 = (0,react.useState)(), nav1 = ref1[0], setNav1 = ref1[1];
    var ref2 = (0,react.useState)(), nav2 = ref2[0], setNav2 = ref2[1];
    var ref3 = (0,react.useState)(videos && videos.map(function() {
        return false;
    })), playing = ref3[0], setPlaying = ref3[1];
    var show = (0,modalProvider/* useModalContext */.vR)().show;
    var cloudflareRefs = (0,react.useRef)(cloudflare && !(0,isEmpty/* default */.Z)(cloudflare) ? cloudflare.map(function() {
        return (0,react.useRef)();
    }) : []);
    var iconWidth = isSmallMobile ? 17 : 22;
    // eslint-disable-next-line no-unused-vars
    var SlickButtonFix = function(_param) /*#__PURE__*/ {
        var currentSlide = _param.currentSlide, slideCount = _param.slideCount, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
            "currentSlide",
            "slideCount",
            "children"
        ]);
        return (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: children
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(slider/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: classnames_default()((0,withModifiers/* withModifiers */.i)("slider", (0,_to_consumable_array/* default */.Z)(variant), (styles_module_default())), className, pagination && (styles_module_default()).withPagination),
                asNavFor: synced && nav2,
                beforeChange: function() {
                    if (playing < cloudflareRefs.current.length) {
                        var ref;
                        // Pause the video when changing slides
                        var videoElement = (ref = cloudflareRefs.current[playing]) === null || ref === void 0 ? void 0 : ref.current;
                        if (videoElement) {
                            videoElement.pause();
                        }
                    }
                    setPlaying(false);
                },
                ref: function(slider1) {
                    return synced && setNav1(slider1);
                },
                slidesToShow: slidesToShow || 3,
                dots: pagination,
                arrows: arrows,
                pagination: pagination && {
                    clickable: true
                },
                nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlickButtonFix, {
                    children: nextArrow || /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_review_next, {
                        width: iconWidth
                    })
                }),
                prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlickButtonFix, {
                    children: prevArrow || /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_review_prev, {
                        width: iconWidth
                    })
                })
            }, props), {
                children: [
                    show && cloudflare && !(0,isEmpty/* default */.Z)(cloudflare) && cloudflare.map(function(video, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudflareVideo, {
                            playing: show && playing[index],
                            reference: cloudflareRefs.current[index],
                            controls: true,
                            src: video,
                            onPlay: function() {
                                return setPlaying(index);
                            },
                            onPause: function() {
                                return setPlaying(false);
                            },
                            onEnded: function() {
                                return setPlaying(false);
                            }
                        }, "video-".concat(video));
                    }),
                    children.length === 1 ? children : children.map(function(item) {
                        return item;
                    })
                ]
            })),
            synced && /*#__PURE__*/ (0,jsx_runtime.jsxs)(slider/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: (styles_module_default()).slider__secondary,
                asNavFor: synced && nav1,
                ref: function(slider2) {
                    return synced && setNav2(slider2);
                },
                arrows: false,
                slidesToShow: isSmallMobile ? 3 : isLargeDesktop ? 4 : 6,
                autoplay: false,
                focusOnSelect: true,
                accessibility: false,
                focusOnChange: false
            }, props), {
                children: [
                    cloudflare && !(0,isEmpty/* default */.Z)(cloudflare) && cloudflare.map(function(_item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            // eslint-disable-next-line no-undef
                            src: "https://customer-".concat("mwbbzmyggbfuda1b", ".cloudflarestream.com/").concat(_item, "/thumbnails/thumbnail.jpg")
                        }, _item);
                    }),
                    children.length === 1 ? children : children.map(function(item) {
                        return item;
                    })
                ]
            }))
        ]
    });
};
/* harmony default export */ var elements_SlickSlider = (SlickSlider);


/***/ }),

/***/ 46125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ stories; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/templates/Page/index.js + 16 modules
var Page = __webpack_require__(51904);
// EXTERNAL MODULE: ./components/elements/Section/index.js
var Section = __webpack_require__(24447);
// EXTERNAL MODULE: ./components/elements/SlickSlider/index.js + 2 modules
var SlickSlider = __webpack_require__(12817);
// EXTERNAL MODULE: ./components/elements/Container/index.js
var Container = __webpack_require__(51524);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-blog-left.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconBlogLeft = props => /*#__PURE__*/react.createElement("svg", _extends({
  viewBox: "0 0 64 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M2.753 24.508h58.732M27.398 46.026 2.748 24.513 27.398 3",
  stroke: "currentcolor",
  strokeWidth: 4.303,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ var icon_blog_left = (SvgIconBlogLeft);
;// CONCATENATED MODULE: ./public/icons/icon-blog-right.svg
var icon_blog_right_path;

function icon_blog_right_extends() { icon_blog_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_blog_right_extends.apply(this, arguments); }



const SvgIconBlogRight = props => /*#__PURE__*/react.createElement("svg", icon_blog_right_extends({
  viewBox: "0 0 64 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_blog_right_path || (icon_blog_right_path = /*#__PURE__*/react.createElement("path", {
  d: "M61.747 24.508H3.015M37.102 46.026l24.65-21.513L37.102 3",
  stroke: "currentColor",
  strokeWidth: 4.303,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ var icon_blog_right = (SvgIconBlogRight);
// EXTERNAL MODULE: ./components/pages/blog/Welcome/styles.module.scss
var styles_module = __webpack_require__(15795);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 8 modules
var CSSTransition = __webpack_require__(73985);
// EXTERNAL MODULE: ./components/helpers/getS3Url.js
var getS3Url = __webpack_require__(27895);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/pages/blog/Welcome/index.js















var formatDate = function(date) {
    if (!date || !date._d) return "";
    var d = moment_default()(date._d).utc();
    return d.format("MMM D");
};
var Welcome = function(param) {
    var buttonLabel = param.buttonLabel, featuredBlogs = param.featuredBlogs;
    var ref = (0,react.useState)(0), active = ref[0], setActive = ref[1];
    var ref1 = (0,ResponsiveContext/* useResponsive */.F)(), isTablet = ref1.isTablet, isLargeDesktop = ref1.isLargeDesktop;
    var router = (0,next_router.useRouter)();
    var width = isTablet ? 24 : isLargeDesktop ? 40 : 60;
    var height = isTablet ? 18 : isLargeDesktop ? 30 : 43;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section["default"], {
        variant: [
            "full-height",
            "p-xs",
            "bottom",
            "o-hidden"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: featuredBlogs && featuredBlogs[router.locale].map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "prefetch",
                        href: (0,getS3Url/* getS3Url */.v)(item.cloudflare_hero_image || item.hero_image, "1980"),
                        as: "image",
                        type: "image/jpeg"
                    }, "prefetch-".concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container["default"], {
                children: [
                    featuredBlogs && featuredBlogs[router.locale].map(function(item, index) {
                        return active === index && /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                            classNames: "opacity",
                            appear: true,
                            in: active === index,
                            timeout: {
                                enter: 200,
                                exit: 200
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).image,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,getS3Url/* getS3Url */.v)(item.cloudflare_hero_image || item.hero_image, "1980"),
                                    srcSet: "\n                ".concat((0,getS3Url/* getS3Url */.v)(item.cloudflare_hero_image || item.hero_image, "360"), " 360w,\n                ").concat((0,getS3Url/* getS3Url */.v)(item.cloudflare_hero_image || item.hero_image, "640"), " 640w,\n                ").concat((0,getS3Url/* getS3Url */.v)(item.cloudflare_hero_image || item.hero_image, "960"), " 960w,\n                ").concat((0,getS3Url/* getS3Url */.v)(item.cloudflare_hero_image || item.hero_image, "1980"), " 1980w,\n                ").concat((0,getS3Url/* getS3Url */.v)(item.cloudflare_hero_image || item.hero_image, "3840"), " 3840w\n              "),
                                    sizes: "100vw",
                                    alt: "Blog Image ".concat(item.title),
                                    fetchpriority: "high"
                                })
                            })
                        }, active);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).overlay
                    }),
                    featuredBlogs && /*#__PURE__*/ (0,jsx_runtime.jsx)(SlickSlider/* default */.Z, {
                        className: (styles_module_default()).slider,
                        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_blog_left, {
                            width: width,
                            height: height
                        }),
                        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_blog_right, {
                            width: width,
                            height: height
                        }),
                        slidesToShow: 1,
                        afterChange: function(index) {
                            return setActive(index);
                        },
                        variant: [
                            "white",
                            "arrow-auto"
                        ],
                        children: featuredBlogs[router.locale].map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
                                variant: [
                                    "-xs5"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (styles_module_default()).slide,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default()).slide__date,
                                            children: formatDate(item.published_date)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: (styles_module_default()).slide__title,
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            dangerouslySetInnerHTML: {
                                                __html: item.short_description
                                            }
                                        }),
                                        item.categories && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (styles_module_default()).slide__tag,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                children: item.categories[0].title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                            href: "/stories/".concat(item.slug),
                                            variant: [
                                                "label"
                                            ],
                                            children: buttonLabel
                                        })
                                    ]
                                })
                            }, "slide-".concat(index));
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var blog_Welcome = (Welcome);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./components/elements/Tabs/styles.module.scss
var Tabs_styles_module = __webpack_require__(94082);
var Tabs_styles_module_default = /*#__PURE__*/__webpack_require__.n(Tabs_styles_module);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
;// CONCATENATED MODULE: ./components/elements/Tabs/index.js






var Tabs = function(param) {
    var content = param.content;
    var ref = (0,react.useState)(0), activeTab = ref[0], setActiveTab = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Tabs_styles_module_default()).tabs,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Tabs_styles_module_default()).tabs__navigation,
                children: content.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        onClick: function() {
                            setActiveTab(index);
                        },
                        arrow: false,
                        variant: [
                            "label"
                        ],
                        className: (0,withModifiers/* withModifiers */.i)("tabs__button", [
                            index === activeTab && "current"
                        ], (Tabs_styles_module_default())),
                        children: item.title
                    }, "tab-button-".concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Tabs_styles_module_default()).tabs__content,
                children: content.map(function(item, index) {
                    return activeTab === index && /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                        classNames: "opacity",
                        appear: true,
                        in: activeTab === index,
                        timeout: {
                            enter: 200,
                            exit: 200
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: item.content
                        }, "tab-content-".concat(index))
                    }, activeTab);
                })
            })
        ]
    });
};
/* harmony default export */ var elements_Tabs = (Tabs);

// EXTERNAL MODULE: ./components/custom/BlogCard/index.js
var BlogCard = __webpack_require__(95948);
// EXTERNAL MODULE: ./node_modules/react-paginate/dist/react-paginate.js
var react_paginate = __webpack_require__(11358);
var react_paginate_default = /*#__PURE__*/__webpack_require__.n(react_paginate);
// EXTERNAL MODULE: ./components/elements/Grid/index.js
var Grid = __webpack_require__(117);
// EXTERNAL MODULE: ./public/icons/icon-pagination-left.svg
var icon_pagination_left = __webpack_require__(45923);
// EXTERNAL MODULE: ./public/icons/icon-pagination-right.svg
var icon_pagination_right = __webpack_require__(55610);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./components/elements/Paginate/styles.module.scss
var Paginate_styles_module = __webpack_require__(36615);
var Paginate_styles_module_default = /*#__PURE__*/__webpack_require__.n(Paginate_styles_module);
;// CONCATENATED MODULE: ./components/elements/Paginate/index.js








var Paginate = function(param) {
    var items = param.items, grid = param.grid, itemsPerPage = param.itemsPerPage, sectionRef = param.sectionRef;
    var scroll = modules["default"].animateScroll;
    var ref = (0,react.useState)(0), itemOffset = ref[0], setItemOffset = ref[1];
    var endOffset = itemOffset + itemsPerPage;
    var currentItems = items.slice(itemOffset, endOffset);
    var pageCount = Math.ceil(items.length / itemsPerPage);
    var handlePageClick = function(event) {
        var ref;
        var newOffset = event.selected * itemsPerPage % items.length;
        sectionRef && scroll.scrollTo(((ref = sectionRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().top) - document.body.getBoundingClientRect().top - 150);
        setItemOffset(newOffset);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Paginate_styles_module_default()).pagination,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                variant: grid,
                children: currentItems && currentItems.map(function(item) {
                    return item;
                })
            }),
            !(items.length <= itemsPerPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
                breakLabel: "...",
                nextLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_pagination_right/* default */.Z, {}),
                onPageChange: handlePageClick,
                pageRangeDisplayed: 5,
                pageCount: pageCount,
                previousLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_pagination_left/* default */.Z, {}),
                renderOnZeroPageCount: null
            })
        ]
    });
};
/* harmony default export */ var elements_Paginate = (Paginate);

;// CONCATENATED MODULE: ./components/pages/blog/Content/index.js










var Content = function(param) {
    var buttonLabel = param.buttonLabel, blogs = param.blogs;
    var isMobile = (0,ResponsiveContext/* useResponsive */.F)().isMobile;
    var ref = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var localeBlogs = blogs[router.locale];
    var blogCategories = localeBlogs && Object.keys(localeBlogs).map(function(item) {
        return item;
    });
    var blogContent = blogCategories && blogCategories.map(function(item) {
        return {
            title: item,
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_Paginate, {
                    sectionRef: ref,
                    items: localeBlogs[item].map(function(blog, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCard/* default */.Z, (0,_object_spread/* default */.Z)({
                            buttonLabel: buttonLabel
                        }, blog), "blog-".concat(index));
                    }),
                    itemsPerPage: 8,
                    grid: [
                        !isMobile && "grid-2"
                    ]
                })
            })
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
        sectionRef: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
            children: blogContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_Tabs, {
                content: blogContent
            })
        })
    });
};
/* harmony default export */ var blog_Content = (Content);

// EXTERNAL MODULE: ./components/pages/blog/Subscribe/index.js + 1 modules
var Subscribe = __webpack_require__(95109);
// EXTERNAL MODULE: ./components/pages/blog/SocialPromo/styles.module.scss
var SocialPromo_styles_module = __webpack_require__(48702);
var SocialPromo_styles_module_default = /*#__PURE__*/__webpack_require__.n(SocialPromo_styles_module);
// EXTERNAL MODULE: ./components/elements/LazyImage/index.js
var LazyImage = __webpack_require__(20027);
// EXTERNAL MODULE: ./components/custom/SocialConnect/index.js + 3 modules
var SocialConnect = __webpack_require__(56218);
;// CONCATENATED MODULE: ./components/pages/blog/SocialPromo/index.js







var SocialPromo = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
        separator: true,
        variant: [
            "gray",
            "separator-top"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
            variant: [
                "-xl2",
                "-p0"
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SocialPromo_styles_module_default()).grid,
                children: Array.from({
                    length: 9
                }).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,withModifiers/* withModifiers */.i)("item", [
                            index + 1
                        ], (SocialPromo_styles_module_default())),
                        children: index !== 4 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.Z, {
                            objectFit: "cover",
                            objectPosition: "center",
                            layout: "fill",
                            src: "/images/image-blog-gal-".concat(index + 1, ".jpg")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialConnect/* default */.Z, {
                                    variant: [
                                        "primary",
                                        "large"
                                    ]
                                })
                            ]
                        })
                    }, "grid-item-".concat(index));
                })
            })
        })
    });
};
/* harmony default export */ var blog_SocialPromo = (SocialPromo);

;// CONCATENATED MODULE: ./pages/stories/index.js







var Blog = function(param) {
    var headerTranslation = param.headerTranslation, footerTranslation = param.footerTranslation, pageTranslations = param.pageTranslations, featuredBlogs = param.featuredBlogs, allPosts = param.allPosts;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page["default"], {
        headerTranslation: headerTranslation,
        footerTranslation: footerTranslation,
        meta: {
            title: pageTranslations.seo.title[router.locale],
            description: pageTranslations.seo.description[router.locale]
        },
        footer: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_Welcome, {
                featuredBlogs: featuredBlogs,
                buttonLabel: pageTranslations.cards.button[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_Content, {
                blogs: allPosts,
                buttonLabel: pageTranslations.cards.button[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subscribe/* default */.Z, {
                title: pageTranslations.subscribe.title[router.locale],
                description: pageTranslations.subscribe.description[router.locale],
                translations: footerTranslation.form
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_SocialPromo, {
                title: pageTranslations.promo.title[router.locale]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var stories = (Blog);


/***/ }),

/***/ 36615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__Ivwzj"};

/***/ }),

/***/ 41227:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles_slider__jV0qF","slider__video":"styles_slider__video__6PYe8","withPagination":"styles_withPagination__IJC8S","slider__secondary":"styles_slider__secondary__iaEjw","slider--white":"styles_slider--white__qLIzX","slider--arrow-auto":"styles_slider--arrow-auto__ze_w3"};

/***/ }),

/***/ 94082:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabs__navigation":"styles_tabs__navigation__rXVhS","tabs__button":"styles_tabs__button__eME9R","tabs__button--current":"styles_tabs__button--current__1IFII","tabs__content":"styles_tabs__content__Qg_lv"};

/***/ }),

/***/ 48702:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__fKOd6","item":"styles_item__HBsE5","item--1":"styles_item--1__esMYx","item--9":"styles_item--9__19nei","item--2":"styles_item--2__KBM_S","item--3":"styles_item--3__heDU_","item--4":"styles_item--4__m373m","item--5":"styles_item--5__qkKlJ","item--6":"styles_item--6__4FUr2","item--7":"styles_item--7__TW3is","item--8":"styles_item--8__2D2Lc"};

/***/ }),

/***/ 15795:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__mF577","slider":"styles_slider__7ItoP","image":"styles_image__lwZWt","slide":"styles_slide__2GSMz","slide__date":"styles_slide__date__tNMpv","slide__title":"styles_slide__title__ONneu","slide__tag":"styles_slide__tag__Secxu"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3790,2756,5675,7549,6820,8433,5798,8094,3817,8174,6268,9774,945,2888,179], function() { return __webpack_exec__(97901); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);